module.exports = global["Rails"] = require("-!/app/node_modules/babel-loader/lib/index.js??ref--12-0!./rails-ujs.js");